/* eslint-disable no-restricted-syntax -- color hex values are user paint data, not UI styling */
export const DEFAULT_COLOR_HEX = '#ffffff';

export const HEX_6_PATTERN = /^#?[0-9a-f]{6}$/i;
export const HEX_3_PATTERN = /^#?[0-9a-f]{3}$/i;

export function normalizeColorHex(value, fallback = DEFAULT_COLOR_HEX) {
  if (typeof value !== 'string') {
    return fallback;
  }

  const trimmed = value.trim();
  if (HEX_6_PATTERN.test(trimmed)) {
    return `#${trimmed.replace('#', '').toLowerCase()}`;
  }

  if (HEX_3_PATTERN.test(trimmed)) {
    const raw = trimmed.replace('#', '').toLowerCase();
    return `#${raw.split('').map((char) => `${char}${char}`).join('')}`;
  }

  return fallback;
}
